import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '~/components/ui/sidebar'
import { useBranding } from '~/helpers/branding/branding-context'
import { useAuth } from '~/helpers/store/auth'
import { backOfficeNav, isNavItemActive } from '~/pages/backoffice/sidebar/back-office-nav'
import { SidebarBrand } from '~/pages/backoffice/sidebar/SidebarBrand'
import { NavUser } from '~/pages/backoffice/sidebar/UserNav'

export function AppSidebar() {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const { payload, capabilities } = useAuth()
  const { billingSelfService } = useBranding()
  const groups = backOfficeNav(payload?.role, capabilities, t, { billingSelfService })

  return (
    // `inset` : le fond de la barre fait le tour du contenu, posé en bloc
    // arrondi (`SidebarInset` dans `BackOfficeLayout`).
    <Sidebar collapsible="icon" variant="inset">
      <SidebarHeader>
        <SidebarBrand />
      </SidebarHeader>
      <SidebarContent>
        <nav aria-label={t('a11y.backOfficeNav')}>
          {groups.map(group => (
            <SidebarGroup key={group.key}>
              {group.label && <SidebarGroupLabel>{group.label}</SidebarGroupLabel>}
              <SidebarGroupContent>
                <SidebarMenu>
                  {group.items.map(item => (
                    <SidebarMenuItem key={item.url}>
                      <SidebarMenuButton asChild isActive={isNavItemActive(pathname, item.url)} tooltip={item.title}>
                        <Link to={item.url}>
                          <item.icon />
                          <span>{item.title}</span>
                        </Link>
                      </SidebarMenuButton>
                    </SidebarMenuItem>
                  ))}
                </SidebarMenu>
              </SidebarGroupContent>
            </SidebarGroup>
          ))}
        </nav>
      </SidebarContent>
      <SidebarFooter>
        <NavUser />
      </SidebarFooter>
    </Sidebar>
  )
}
